$(function () {
    // CSRF token into ajax forms
    if (typeof token !== 'undefined') {
        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': token }
        });
    }

    $('.subscribe').off('click').on('click', subscription);
});

function subscription(e) {
    e.preventDefault();

    var $el = $(this);
    var $wrap = $el.closest('form, .subscribe-form, [data-subscribe-wrap]').length
        ? $el.closest('form, .subscribe-form, [data-subscribe-wrap]')
        : $el.parent().parent();

    var email = $wrap.find('[name="email"]').val();

    if ($el.hasClass('disabled')) return;

    // Clear previous errors (Tailwind)
    clearErrors($wrap);

    $.ajax({
        method: 'POST',
        url: subscribeRoute,
        data: { email: email },
        beforeSend: function () {
            $el.addClass('disabled').attr('aria-disabled', 'true');
        },
        complete: function () {
            $el.removeClass('disabled').removeAttr('aria-disabled');
        },
        success: function (data) {
            if (data && typeof data.success !== 'undefined') {
                $('.subscribe-form').addClass('hidden');
                $('.subscribed').removeClass('hidden');
            }
        },
        error: function (error) {
            var errors = error?.responseJSON?.errors;
            if (!errors) return;

            for (var item in errors) {
                var $field = $wrap.find('[name="' + item + '"],[name="' + item + '[]"]:last').first();
                if (!$field.length) continue;

                // Add Tailwind error styles to input
                $field
                    .addClass('ring-2 ring-red-500 border-red-500')
                    .attr('aria-invalid', 'true');

                // Find or create an error message element near the field
                var $msg = $field.parent().find('[data-error-for="' + item + '"]');

                if (!$msg.length) {
                    $msg = $('<p/>', {
                        'data-error-for': item,
                        'class': 'mt-2 text-sm text-red-600'
                    }).appendTo($field.parent());
                }

                $msg.text(errors[item]);
            }
        }
    });
}

function clearErrors($wrap) {
    // remove error styles from inputs
    $wrap.find('[aria-invalid="true"]').each(function () {
        $(this)
            .removeClass('ring-2 ring-red-500 border-red-500')
            .removeAttr('aria-invalid');
    });

    // remove inline error messages
    $wrap.find('[data-error-for]').remove();
}

// main.js
(() => {
    const ready = (fn) => {
        if (document.readyState !== "loading") fn();
        else document.addEventListener("DOMContentLoaded", fn);
    };

    ready(() => {
        setupJqueryCsrf();
        initFlywheels();
        initStallStepObservers();
        initCaseStudyCarousels();
        initTestimonialsCarousels();
        initSquadCarousels();
        initNewsletterBlocks();

        // Legacy support (if you still have old ".subscribe" buttons somewhere)
        if (window.jQuery) {
            window.jQuery(".subscribe").off("click").on("click", window.subscription);
        }
    });

    function setupJqueryCsrf() {
        if (!window.jQuery) return;
        if (typeof window.token !== "undefined") {
            window.jQuery.ajaxSetup({
                headers: { "X-CSRF-TOKEN": window.token },
            });
        }
    }

    // ---------------------------------------------------------------------
    // Flywheel
    // ---------------------------------------------------------------------
    function initFlywheels() {
        const SEGMENTS = {
            audit: {
                title: "AUDIT",
                description:
                    "A deep diagnostic of your Amazon ecosystem—including SEO, PDP health, pricing, reviews, catalog structure, content effectiveness, advertising efficiency, and competitive benchmarking—to identify the fastest paths to incremental growth.",
                angle: -90,
            },
            strategy: {
                title: "STRATEGY",
                description:
                    "A full-funnel growth roadmap leveraging SEO insights, competitive intel, demand forecasting, and media planning across Amazon, DSP, AMC, Walmart, and social commerce to create a profit-first acceleration plan.",
                angle: -45,
            },
            content: {
                title: "CONTENT",
                description:
                    "High-conversion optimized creative including A+ Content, Brand Stores, SEO-optimized copy, graphic design, lifestyle & product imagery, video, UGC, and VoC-driven storytelling engineered to increase relevance and conversion.",
                angle: 0,
            },
            pdps: {
                title: "PDPs & BRAND STORE",
                description:
                    "Best-in-class PDP and Brand Store builds with keyword-rich copy, optimized imagery, comparison charts, video enhancements, and cohesive brand narratives to improve CVR, discoverability, and overall shopper engagement.",
                angle: 45,
            },
            advertising: {
                title: "ADVERTISING",
                description:
                    "Integrated media execution across Sponsored Ads, Sponsored Brands, Sponsored Display, Amazon DSP, AMC audience modeling, retargeting, and full-funnel attribution to maximize ROAS while reducing wasted spend.",
                angle: 90,
            },
            execution: {
                title: "EXECUTION",
                description:
                    "End-to-end operational management—campaign builds, listing updates, variation fixes, inventory alignment, pricing governance, and launch activation—to ensure flawless execution and consistent marketplace performance.",
                angle: 135,
            },
            tracking: {
                title: "TRACKING",
                description:
                    "Real-time analytics with the SUG Dashboard, KPI’s, AMC insights, share-of-voice tracking, TACoS monitoring, and conversion diagnostics to continuously measure performance and uncover actionable optimization opportunities.",
                angle: 180,
            },
            optimization: {
                title: "OPTIMIZATION",
                description:
                    "Ongoing refinement of SEO, content, media, and operational levers through testing, bid automation, creative refreshes, PDP refinements, and AMC-driven audience improvements to unlock continuous growth at scale.",
                angle: -135,
            },
        };

        const ACTIVE_WEDGE = "#ee9b7f";
        const ACTIVE_LABEL = "#dedede";

        document.querySelectorAll("[data-flywheel]").forEach((root) => initFlywheel(root));

        function initFlywheel(root) {
            if (root.dataset.inited === "1") return;
            root.dataset.inited = "1";

            const url = root.getAttribute("data-svg-url") || "img/sug-flywheel.svg";
            const mount = root.querySelector("[data-flywheel-svg]");
            const card = root.querySelector("[data-flywheel-card]");
            const titleEl = root.querySelector("[data-flywheel-title]");
            const bodyEl = root.querySelector("[data-flywheel-body]");
            if (!mount || !card || !titleEl || !bodyEl) return;

            let pinned = null;

            fetch(url)
                .then((r) => r.text())
                .then((svgText) => {
                    svgText = svgText.replace(/<\?xml[\s\S]*?\?>/i, "").trim();
                    mount.innerHTML = svgText;

                    const svg = mount.querySelector("svg");
                    if (!svg) return;

                    svg.querySelectorAll("*").forEach((n) => (n.style.pointerEvents = "none"));
                    svg.querySelectorAll("g.cls-7 > path.cls-1, rect.cls-6, text.cls-9, text.cls-10")
                        .forEach((n) => (n.style.pointerEvents = "auto"));

                    svg.classList.add("w-full", "h-auto", "select-none");
                    svg.style.overflow = "visible";

                    const vb = svg.viewBox.baseVal;
                    const cx = vb.x + vb.width / 2;
                    const cy = vb.y + vb.height / 2;

                    const wedges = svg.querySelectorAll("g.cls-7 > path.cls-1");
                    wedges.forEach((p) => makeInteractive(p, closestSeg(angleFromBBoxCenter(p, cx, cy))));

                    const labelRects = svg.querySelectorAll("rect.cls-6");
                    labelRects.forEach((rect) => {
                        const seg = closestSeg(angleFromBBoxCenter(rect, cx, cy));
                        makeInteractive(rect, seg);

                        const txt = rect.nextElementSibling;
                        if (txt && txt.tagName && txt.tagName.toLowerCase() === "text") makeInteractive(txt, seg);
                    });

                    // Tag icon shapes so they fade with their segment
                    const wedgeDists = [...wedges].map((el) => distFromBBoxCenter(el, cx, cy));
                    const dMid = wedgeDists.reduce((a, b) => a + b, 0) / (wedgeDists.length || 1);
                    const ringInner = dMid * 0.55;
                    const ringOuter = dMid * 1.55;

                    const iconEls = svg.querySelectorAll(
                        "path.cls-5, path.cls-2, polygon.cls-5, polyline.cls-5, line.cls-5, rect.cls-5"
                    );

                    iconEls.forEach((el) => {
                        const dist = distFromBBoxCenter(el, cx, cy);
                        if (dist < ringInner || dist > ringOuter) return;
                        if (!el.dataset.seg) el.dataset.seg = closestSeg(angleFromBBoxCenter(el, cx, cy));
                    });

                    // click outside = unpin
                    document.addEventListener("click", () => {
                        if (!pinned) return;
                        pinned = null;
                        setActive(null);
                    });

                    function makeInteractive(el, seg) {
                        el.dataset.seg = seg;
                        el.style.cursor = "pointer";
                        const tag = el.tagName.toLowerCase();
                        if (tag === "path" || tag === "rect") el.style.transition = "fill 500ms ease";

                        el.addEventListener("pointerenter", () => {
                            if (!pinned) setActive(seg);
                        });
                        el.addEventListener("pointerleave", () => {
                            if (!pinned) setActive(null);
                        });
                        el.addEventListener("click", (e) => {
                            e.stopPropagation();
                            pinned = pinned === seg ? null : seg;
                            setActive(pinned || seg);
                        });
                    }

                    function setActive(seg) {
                        const segEls = svg.querySelectorAll("[data-seg]");
                        if (!seg) segEls.forEach((el) => (el.style.opacity = ""));
                        else segEls.forEach((el) => (el.style.opacity = el.dataset.seg === seg ? "1" : "0.85"));

                        svg.querySelectorAll("path.cls-1[data-seg]").forEach((p) => {
                            p.style.fill = seg && p.dataset.seg === seg ? ACTIVE_WEDGE : "";
                        });
                        svg.querySelectorAll("rect.cls-6[data-seg]").forEach((r) => {
                            r.style.fill = seg && r.dataset.seg === seg ? ACTIVE_LABEL : "";
                        });

                        if (!seg) {
                            card.classList.add("opacity-0", "scale-95");
                            card.classList.remove("opacity-100", "scale-100");
                            return;
                        }

                        titleEl.textContent = SEGMENTS[seg].title;
                        bodyEl.textContent = SEGMENTS[seg].description;

                        card.classList.remove("opacity-0", "scale-95");
                        card.classList.add("opacity-100", "scale-100");
                    }

                    function angleFromBBoxCenter(el, cx, cy) {
                        const bb = el.getBBox();
                        const x = bb.x + bb.width / 2;
                        const y = bb.y + bb.height / 2;
                        return (Math.atan2(y - cy, x - cx) * 180) / Math.PI;
                    }

                    function distFromBBoxCenter(el, cx, cy) {
                        const bb = el.getBBox();
                        const x = bb.x + bb.width / 2;
                        const y = bb.y + bb.height / 2;
                        return Math.hypot(x - cx, y - cy);
                    }

                    function closestSeg(angle) {
                        let bestKey = null;
                        let bestDiff = Infinity;
                        for (const [key, info] of Object.entries(SEGMENTS)) {
                            const diff = angleDistance(angle, info.angle);
                            if (diff < bestDiff) {
                                bestDiff = diff;
                                bestKey = key;
                            }
                        }
                        return bestKey;
                    }

                    function angleDistance(a, b) {
                        let d = a - b;
                        while (d > 180) d -= 360;
                        while (d < -180) d += 360;
                        return Math.abs(d);
                    }
                })
                .catch(() => {
                    // fail silently on missing SVG
                });
        }
    }

    // ---------------------------------------------------------------------
    // "Stall steps" IntersectionObserver (supports multiple sections)
    // ---------------------------------------------------------------------
    function initStallStepObservers() {
        document.querySelectorAll("[data-stall-steps]").forEach((wrap) => {
            const steps = Array.from(wrap.querySelectorAll("[data-step]"));
            if (!steps.length) return;

            let active = 0;

            const setActive = (idx) => {
                if (idx === active) return;
                steps[active].dataset.active = "false";
                steps[idx].dataset.active = "true";
                active = idx;
            };

            // init
            steps.forEach((el, i) => (el.dataset.active = i === 0 ? "true" : "false"));

            const io = new IntersectionObserver(
                (entries) => {
                    // only react to "entering" the band
                    const entering = entries.filter((e) => e.isIntersecting);
                    if (!entering.length) return;

                    // in case of a rare tie, pick the one closest to the top of the band
                    entering.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

                    const idx = steps.indexOf(entering[0].target);
                    if (idx !== -1) setActive(idx);
                },
                {
                    root: null,
                    // super thin middle band (~2% of viewport height)
                    rootMargin: "-49% 0px -49% 0px",
                    threshold: 0,
                }
            );

            steps.forEach((s) => io.observe(s));
        });
    }

    // ---------------------------------------------------------------------
    // Case studies arrows
    // ---------------------------------------------------------------------
    function initCaseStudyCarousels() {
        document.querySelectorAll("[data-case-wrap]").forEach((wrap) => {
            if (wrap.dataset.inited === "1") return;
            wrap.dataset.inited = "1";

            const scroller = wrap.querySelector("[data-case-carousel]");
            const prev = wrap.querySelector("[data-case-prev]");
            const next = wrap.querySelector("[data-case-next]");
            if (!scroller) return;

            const step = () => {
                const card = scroller.querySelector("[data-case-item]");
                if (!card) return scroller.clientWidth;
                const styles = getComputedStyle(scroller);
                const gap = parseFloat(styles.gap || styles.columnGap || 0);
                return card.getBoundingClientRect().width + gap;
            };

            prev?.addEventListener("click", () => scroller.scrollBy({ left: -step(), behavior: "smooth" }));
            next?.addEventListener("click", () => scroller.scrollBy({ left: step(), behavior: "smooth" }));
        });
    }

    // ---------------------------------------------------------------------
    // Testimonials carousel (infinite feel; no disabling)
    // ---------------------------------------------------------------------
    function initTestimonialsCarousels() {
        document.querySelectorAll("[data-testimonials]").forEach((root) => {
            if (root.dataset.inited === "1") return;
            root.dataset.inited = "1";

            const track = root.querySelector("[data-track]");
            const prev = root.querySelector("[data-prev]");
            const next = root.querySelector("[data-next]");
            if (!track || !prev || !next) return;

            const slideWidth = () => track.clientWidth;
            const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

            const go = (dir) => {
                const max = maxScroll();
                const x = track.scrollLeft;
                const w = slideWidth();

                // Wrap
                if (dir < 0 && x <= 2) return track.scrollTo({ left: max, behavior: "smooth" });
                if (dir > 0 && x >= max - 2) return track.scrollTo({ left: 0, behavior: "smooth" });

                track.scrollBy({ left: dir * w, behavior: "smooth" });
            };

            prev.addEventListener("click", () => go(-1));
            next.addEventListener("click", () => go(1));
        });
    }

    // ---------------------------------------------------------------------
    // Squad carousel arrows
    // ---------------------------------------------------------------------
    function initSquadCarousels() {
        document.querySelectorAll("[data-squad]").forEach((wrap) => {
            if (wrap.dataset.inited === "1") return;
            wrap.dataset.inited = "1";

            const track = wrap.querySelector("[data-squad-track]");
            const prev = wrap.querySelector("[data-squad-prev]");
            const next = wrap.querySelector("[data-squad-next]");
            if (!track) return;

            const step = () => {
                const first = track.querySelector("[data-squad-item]");
                if (!first) return track.clientWidth;
                const cs = getComputedStyle(track);
                const gap = parseFloat(cs.columnGap || cs.gap || "0") || 0;
                return first.getBoundingClientRect().width + gap;
            };

            prev?.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
            next?.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
        });
    }

    // ---------------------------------------------------------------------
    // Newsletter (new Tailwind block) — open/close + submit + success + hide cancel
    // ---------------------------------------------------------------------
    function initNewsletterBlocks() {
        const csrf =
            window.token ||
            document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

        document.querySelectorAll("[data-newsletter]").forEach((root) => {
            if (root.dataset.inited === "1") return;
            root.dataset.inited = "1";

            const ctaWrap = root.querySelector("[data-newsletter-cta]");
            const formWrap = root.querySelector("[data-newsletter-formwrap]");
            const openBtn = root.querySelector("[data-newsletter-open]");
            const cancelBtn = root.querySelector("[data-newsletter-cancel]");
            const form = formWrap?.querySelector("form");
            const emailInput =
                root.querySelector("[data-newsletter-email]") ||
                form?.querySelector('input[name="email"]');
            const submitBtn =
                root.querySelector("[data-newsletter-submit]") ||
                form?.querySelector('button[type="submit"]');
            const errorEl = root.querySelector("[data-newsletter-error]");
            const subscribed = root.querySelector(".subscribed");

            if (!ctaWrap || !formWrap || !openBtn || !cancelBtn || !form || !emailInput || !submitBtn) return;

            const clearError = () => {
                if (errorEl) {
                    errorEl.textContent = "";
                    errorEl.classList.add("hidden");
                }
                emailInput.classList.remove("ring-2", "ring-red-500", "border-red-500");
                emailInput.removeAttribute("aria-invalid");
            };

            const showError = (msg) => {
                if (errorEl) {
                    errorEl.textContent = msg;
                    errorEl.classList.remove("hidden");
                }
                emailInput.classList.add("ring-2", "ring-red-500", "border-red-500");
                emailInput.setAttribute("aria-invalid", "true");
            };

            const open = () => {
                clearError();
                subscribed?.classList.add("hidden");
                form.querySelector(".subscribe-form")?.classList.remove("hidden");
                cancelBtn?.classList.remove("hidden");

                ctaWrap.classList.add("hidden");
                formWrap.classList.remove("hidden");

                requestAnimationFrame(() => emailInput.focus());
            };

            const close = () => {
                clearError();
                formWrap.classList.add("hidden");
                ctaWrap.classList.remove("hidden");
                openBtn.focus();
            };

            openBtn.addEventListener("click", open);
            cancelBtn.addEventListener("click", close);

            window.addEventListener("keydown", (e) => {
                if (e.key === "Escape" && !formWrap.classList.contains("hidden")) close();
            });

            form.addEventListener("submit", async (e) => {
                e.preventDefault();
                clearError();

                const email = (emailInput.value || "").trim();
                if (!email) {
                    showError("The email field is required.");
                    return;
                }

                submitBtn.disabled = true;

                try {
                    const url =
                        window.subscribeRoute ||
                        form.getAttribute("action") ||
                        "/newsletter/subscribe";

                    const body = new URLSearchParams(new FormData(form));

                    const res = await fetch(url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            ...(csrf ? { "X-CSRF-TOKEN": csrf } : {}),
                            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        },
                        body,
                    });

                    const data = await res.json().catch(() => ({}));

                    if (!res.ok) {
                        const msg =
                            data?.errors?.email?.[0] ||
                            data?.message ||
                            "Something went wrong. Please try again.";
                        showError(msg);
                        return;
                    }

                    // success
                    form.querySelector(".subscribe-form")?.classList.add("hidden");
                    subscribed?.classList.remove("hidden");
                    cancelBtn?.classList.add("hidden"); // remove cancel after submitting
                } catch (err) {
                    showError("Network error. Please try again.");
                } finally {
                    submitBtn.disabled = false;
                }
            });
        });
    }
})();

// -------------------------------------------------------------------------
// Legacy subscribe handler (jQuery) — fixed to scope success/errors per wrap
// -------------------------------------------------------------------------
window.subscription = function subscription(e) {
    e.preventDefault();
    if (!window.jQuery) return;

    var $ = window.jQuery;
    var $el = $(this);
    var $wrap =
        $el.closest("form, .subscribe-form, [data-subscribe-wrap]").length
            ? $el.closest("form, .subscribe-form, [data-subscribe-wrap]")
            : $el.parent().parent();

    var email = $wrap.find('[name="email"]').val();
    if ($el.hasClass("disabled")) return;

    window.clearErrors($wrap);

    $.ajax({
        method: "POST",
        url: window.subscribeRoute,
        data: { email: email },
        beforeSend: function () {
            $el.addClass("disabled").attr("aria-disabled", "true");
        },
        complete: function () {
            $el.removeClass("disabled").removeAttr("aria-disabled");
        },
        success: function (data) {
            if (data && typeof data.success !== "undefined") {
                $wrap.find(".subscribe-form").addClass("hidden");
                $wrap.find(".subscribed").removeClass("hidden");
                $wrap.find("[data-newsletter-cancel]").addClass("hidden");
            }
        },
        error: function (error) {
            var errors = error?.responseJSON?.errors;
            if (!errors) return;

            for (var item in errors) {
                var $field = $wrap.find('[name="' + item + '"],[name="' + item + '[]"]:last').first();
                if (!$field.length) continue;

                $field.addClass("ring-2 ring-red-500 border-red-500").attr("aria-invalid", "true");

                // Use existing error element if present, otherwise create one
                var $msg =
                    $wrap.find("[data-newsletter-error]").first().length
                        ? $wrap.find("[data-newsletter-error]").first()
                        : $field.parent().find('[data-error-for="' + item + '"]');

                if (!$msg.length) {
                    $msg = $("<p/>", {
                        "data-error-for": item,
                        class: "mt-2 text-sm text-red-600",
                    }).appendTo($field.parent());
                }

                $msg.text(errors[item]).removeClass("hidden");
            }
        },
    });
};

window.clearErrors = function clearErrors($wrap) {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    $wrap.find('[aria-invalid="true"]').each(function () {
        $(this).removeClass("ring-2 ring-red-500 border-red-500").removeAttr("aria-invalid");
    });

    $wrap.find("[data-error-for]").remove();

    // If the Tailwind newsletter error node exists
    $wrap.find("[data-newsletter-error]").text("").addClass("hidden");
};
